import ui from "./ui.module.css";

// The picture and word on an item card. Either may be missing: a picture
// that is not available leaves the word, and the word is optional.
const Picture = ({ item }) => (
  <>
    {item.asset ? (
      <img
        className={ui.choiceImage}
        src={item.asset.src}
        alt={item.asset.alt}
      />
    ) : item.emoji ? (
      <span className={ui.choicePicture} aria-hidden="true">
        {item.emoji}
      </span>
    ) : null}
    {item.label && <span className={ui.choiceLabel}>{item.label}</span>}
  </>
);

export default Picture;
